import { Component } from '@angular/core';

@Component({
  selector: 'app-paye-fac-f',
  templateUrl: './paye-fac-f.component.html',
  styleUrls: ['./paye-fac-f.component.scss']
})
export class PayeFacFComponent {}
